import { createSelector } from 'reselect';

import { RootState } from '..';

export const selectUI = (state: RootState) => {
  return state.ui;
};

export const selectIsShowFooterPopUp = createSelector(selectUI, (ui) => {
  return ui.isShowFooterPopUp;
});

export const selectIsShowJoinToSpacePopup = createSelector(selectUI, (ui) => {
  return ui.isShowJoinToSpacePopup;
});

export const selectShouldInitPubnub = createSelector(selectUI, (ui) => {
  return ui.shouldInitPubnub;
});

export const selectIsShowShares = createSelector(selectUI, (ui) => {
  return ui.isShowShares;
});
